import { findDocument } from './find-document';

import { TYPE_CHAPTER } from '../constants';

const traverse = async ({ data, items, level, path }: any, callback: any) => {
  let number = 1;

  for (const { children, id } of data) {
    // find the current item
    const item = findDocument(items, id);

    // skip onther numbers
    const index = item.type === TYPE_CHAPTER ? number++ : null;

    const count = path.length - level;

    if (count > 0) {
      for (let counter = 0; counter < count; counter++) {
        path.pop();
      }
    }

    await callback({ ...item, path: [...path, index] });

    if (children) {
      if (!level) {
        // eslint-disable-next-line no-param-reassign
        path = [];
      }

      path.push(index);

      await traverse({ items, data: children, level: level + 1, path }, callback);
    }
  }
};

export default traverse;
